
import getNetwork, { defaultChain } from "@/model/Networks";
import { ensureWeb3 } from "@/web3/utils";
import { BigNumber } from "@ethersproject/bignumber";
import { defineComponent } from "@vue/runtime-core";
import { AbiItem } from "web3-utils";

import * as faucetTokenAbi from "../../contracts/faucetTokenAbi.json";

declare global {
  interface Window {
    ethereum: any;
  }
}

// import Button from "./CustomButton.vue";
export default defineComponent({
  name: "Wallet",
  data: function () {
    return {
      balance: 0,
      tokenSymbol: "-",
    };
  },
  computed: {
    network: function () {
      return this.$store.state.network;
    },
    address: function () {
      return this.$store.state.account;
    },
    metaMaskInstalled: function () {
      return typeof window.ethereum !== "undefined";
    },
    shortAddress: function () {
      let add = this.address;
      return add.substring(0, 6) + "..." + add.substring(add.length - 4);
    },
  },
  watch: {
    network: function () {
      this.updateToken();
    },
  },
  mounted: async function () {
    if (this.metaMaskInstalled) {
      let provider = window.ethereum;

      this.connectWallet();
      provider.on("connect", () => {
        this.connectWallet();
      });

      window.ethereum.on("chainChanged", () => {
        this.updateNetwork();
      });

      let accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      if (accounts && accounts.length > 0)
        this.$store.commit("setAccount", accounts[0]);

      window.ethereum.on("accountsChanged", (accounts) => {
        this.$store.commit("setAccount", accounts[0]);
        window.location.reload();
      });

      this.updateToken();
    }
  },
  methods: {
    updateToken: async function () {
      const web3 = await ensureWeb3();

      const contract = await new web3.eth.Contract(
        faucetTokenAbi.abi as AbiItem[],
        this.$store.state.network.ustContractAddress
      );
      this.balance = await contract.methods
        .balanceOf(this.$store.state.account)
        .call();

      this.tokenSymbol = await contract.methods.symbol().call();
    },
    faucet: async function () {
      const web3 = await ensureWeb3();

      const contract = await new web3.eth.Contract(
        faucetTokenAbi.abi as AbiItem[],
        this.$store.state.network.ustContractAddress
      );

      await contract.methods
        .faucet(
          this.$store.state.account,
          BigNumber.from(String(10000)).mul(String(Math.pow(10, 18)))
        )
        .send({ from: this.$store.state.account });
      await this.updateToken();
    },
    copy: function (evt) {
      evt.target.select();
      document.execCommand("Copy");
      window.getSelection().removeAllRanges();

      evt.target.parentNode.classList.add("copied");
      setTimeout(() => evt.target.parentNode.classList.remove("copied"), 1000);
    },
    requestDefaultChain: async function () {
      let chainId = "0x" + defaultChain.chainId.toString(16); // chainId must be in hexadecimal numbers

      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId }],
      });
    },
    connectWallet: async function () {
      if (this.metaMaskInstalled) {
        console.log("Connect wallet ...");

        let accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });

        this.$store.commit("setAccount", accounts[0]);
        this.updateNetwork();
      }
    },
    updateNetwork() {
      const network = getNetwork(parseInt(window.ethereum.chainId, 16));
      this.$store.commit("setNetwork", network);
    },
  },
});
